export const APPLICATION_STATUS = Object.freeze({
  DRAFT: 'Draft',
  SUBMITTED: 'Submitted',
  PAYMENT_REJECTED: 'Payment Rejected',
  DOCUMENTS_PENDING: 'Documents Pending',
  DOCUMENTS_APPROVED: 'Documents Approved',
  APPROVED: 'Approved',
  REJECTED: 'Rejected',
  CANCELLED: 'Cancelled',
  WITHDRAWN: 'Withdrawn',
  EXPIRED: 'Expired',
  UNDER_REVIEW: 'Under Review',
  ELIGIBILITY_VERIFIED: 'Eligibility Verified'
});

const LEGACY_PRE_APPROVAL_STATUSES = [
  APPLICATION_STATUS.ELIGIBILITY_VERIFIED,
  APPLICATION_STATUS.UNDER_REVIEW
];

export const PAYMENT_VERIFICATION_PANEL_STATUSES = [
  APPLICATION_STATUS.SUBMITTED,
  APPLICATION_STATUS.PAYMENT_REJECTED,
  APPLICATION_STATUS.DOCUMENTS_PENDING,
  APPLICATION_STATUS.DOCUMENTS_APPROVED,
  APPLICATION_STATUS.APPROVED,
  // Keep payment history visible after terminal outcomes (collection actions stay blocked)
  APPLICATION_STATUS.REJECTED,
  APPLICATION_STATUS.CANCELLED,
  APPLICATION_STATUS.WITHDRAWN,
  ...LEGACY_PRE_APPROVAL_STATUSES
];

export const PRE_PAYMENT_VERIFICATION_STATUSES = [
  APPLICATION_STATUS.SUBMITTED,
  APPLICATION_STATUS.PAYMENT_REJECTED,
  ...LEGACY_PRE_APPROVAL_STATUSES
];

export const FINAL_DECISION_STATUSES = [
  APPLICATION_STATUS.DOCUMENTS_APPROVED,
  ...LEGACY_PRE_APPROVAL_STATUSES
];

export const PUBLIC_FORM_LOCKED_STATUSES = [
  APPLICATION_STATUS.SUBMITTED,
  APPLICATION_STATUS.PAYMENT_REJECTED,
  APPLICATION_STATUS.DOCUMENTS_PENDING,
  APPLICATION_STATUS.DOCUMENTS_APPROVED,
  APPLICATION_STATUS.APPROVED,
  APPLICATION_STATUS.REJECTED,
  APPLICATION_STATUS.CANCELLED,
  APPLICATION_STATUS.WITHDRAWN,
  APPLICATION_STATUS.EXPIRED,
  ...LEGACY_PRE_APPROVAL_STATUSES
];

export const APPLICATION_STATUS_BADGES = {
  [APPLICATION_STATUS.DRAFT]: 'bg-gray-100 text-gray-800 border-gray-200',
  [APPLICATION_STATUS.SUBMITTED]: 'bg-blue-100 text-blue-800 border-blue-200',
  [APPLICATION_STATUS.PAYMENT_REJECTED]: 'bg-red-100 text-red-800 border-red-200',
  [APPLICATION_STATUS.DOCUMENTS_PENDING]: 'bg-amber-100 text-amber-800 border-amber-200',
  [APPLICATION_STATUS.DOCUMENTS_APPROVED]: 'bg-lime-100 text-lime-800 border-lime-200',
  [APPLICATION_STATUS.APPROVED]: 'bg-green-100 text-green-800 border-green-200',
  [APPLICATION_STATUS.REJECTED]: 'bg-red-100 text-red-800 border-red-200',
  [APPLICATION_STATUS.CANCELLED]: 'bg-orange-100 text-orange-800 border-orange-200',
  [APPLICATION_STATUS.WITHDRAWN]: 'bg-gray-100 text-gray-700 border-gray-200',
  [APPLICATION_STATUS.EXPIRED]: 'bg-gray-100 text-gray-700 border-gray-200',
  [APPLICATION_STATUS.UNDER_REVIEW]: 'bg-yellow-100 text-yellow-800 border-yellow-200',
  [APPLICATION_STATUS.ELIGIBILITY_VERIFIED]: 'bg-indigo-100 text-indigo-800 border-indigo-200'
};

/** Display names where they differ from the stored value (stored value stays 'Approved'). */
const APPLICATION_STATUS_LABELS = Object.freeze({
  [APPLICATION_STATUS.APPROVED]: 'All Approved'
});

export const getApplicationStatusLabel = (status) => APPLICATION_STATUS_LABELS[status] || status;

export const canShowPaymentVerificationPanel = (status) =>
  PAYMENT_VERIFICATION_PANEL_STATUSES.includes(status);

export const canPerformFinalApplicationDecision = (status) =>
  FINAL_DECISION_STATUSES.includes(status);

export const isPublicFormLocked = (status) =>
  PUBLIC_FORM_LOCKED_STATUSES.includes(status);
